import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/card-grooming.png")